module.exports = __webpack_public_path__ + "static/media/abstract2.0400cc38.jpg";